var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 93,
    viewBox: "0 0 85 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8574 23.1754L10.28 66.6797L60.5143 80.1399L48.8574 23.1754Z",
    fill: "url(#paint0_linear_2269_29254)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54522 69.6357C2.39829 66.452 5.67074 64.5626 8.85444 65.4157L61.5594 79.538C64.7431 80.391 66.6324 83.6635 65.7793 86.8472C64.9263 90.0309 61.6538 91.9202 58.4701 91.0672L5.76521 76.9449C2.58151 76.0918 0.692154 72.8194 1.54522 69.6357Z",
    fill: "url(#paint1_radial_2269_29254)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8974 82.0085L8.19246 67.8863C6.37321 67.3988 4.50324 68.4784 4.01577 70.2977C3.5283 72.1169 4.60793 73.9869 6.42719 74.4744L59.1321 88.5966C60.9514 89.0841 62.8213 88.0044 63.3088 86.1852C63.7963 84.3659 62.7166 82.496 60.8974 82.0085ZM8.85444 65.4157C5.67074 64.5626 2.39829 66.452 1.54522 69.6357C0.692154 72.8194 2.58151 76.0918 5.76521 76.9449L58.4701 91.0672C61.6538 91.9202 64.9263 90.0309 65.7793 86.8472C66.6324 83.6635 64.7431 80.391 61.5594 79.538L8.85444 65.4157Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4674 12.326C50.5954 10.1801 53.85 11.0521 53.7539 13.4745C53.6916 15.0445 55.2019 16.2034 56.7022 15.7369C59.0172 15.0171 60.7019 17.9351 58.9211 19.58C57.7669 20.6461 58.0154 22.5335 59.4061 23.2645C61.552 24.3925 60.68 27.6471 58.2576 27.551C56.6876 27.4887 55.5288 28.999 55.9952 30.4993C56.715 32.8143 53.797 34.499 52.1521 32.7182C51.086 31.564 49.1986 31.8125 48.4676 33.2033C47.3396 35.3492 44.085 34.4771 44.1811 32.0547C44.2434 30.4847 42.7331 29.3259 41.2328 29.7924C38.9178 30.5121 37.2331 27.5942 39.0139 25.9492C40.1681 24.8831 39.9196 22.9958 38.5288 22.2647C36.3829 21.1367 37.255 17.8821 39.6774 17.9782C41.2474 18.0405 42.4062 16.5302 41.9397 15.0299C41.22 12.7149 44.1379 11.0302 45.7829 12.811C46.849 13.9652 48.7363 13.7167 49.4674 12.326Z",
    fill: "url(#paint2_radial_2269_29254)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3928 10.8035C43.9512 7.55917 38.3075 10.8175 39.3964 15.4202C34.6687 15.5597 32.9821 21.8544 37.0066 24.339C33.7623 27.7806 37.0207 33.4242 41.6233 32.3354C41.7628 37.063 48.0575 38.7497 50.5421 34.7252C53.9837 37.9695 59.6274 34.7111 58.5385 30.1085C63.2662 29.969 64.9528 23.6743 60.9283 21.1897C64.1726 17.748 60.9143 12.1044 56.3116 13.1933C56.1721 8.46561 49.8774 6.77896 47.3928 10.8035ZM53.7539 13.4742C53.8499 11.0518 50.5954 10.1798 49.4674 12.3257C48.7363 13.7164 46.849 13.9649 45.7829 12.8108C44.1379 11.0299 41.2199 12.7146 41.9397 15.0296C42.4062 16.53 41.2473 18.0402 39.6774 17.9779C37.255 17.8819 36.3829 21.1364 38.5288 22.2644C39.9196 22.9955 40.1681 24.8828 39.0139 25.9489C37.2331 27.5939 38.9177 30.5119 41.2327 29.7921C42.7331 29.3256 44.2433 30.4845 44.1811 32.0544C44.085 34.4768 47.3396 35.3489 48.4676 33.203C49.1986 31.8122 51.086 31.5637 52.1521 32.7179C53.797 34.4987 56.715 32.814 55.9952 30.4991C55.5287 28.9987 56.6876 27.4885 58.2575 27.5507C60.68 27.6468 61.552 24.3922 59.4061 23.2642C58.0153 22.5332 57.7669 20.6458 58.921 19.5797C60.7019 17.9348 59.0172 15.0168 56.7022 15.7366C55.2018 16.2031 53.6916 15.0442 53.7539 13.4742Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2269_29254",
    x1: 48.8574,
    y1: 23.1754,
    x2: 35.3972,
    y2: 73.4098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2269_29254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6623 78.2414) rotate(105) scale(5.96795 33.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2269_29254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9673 22.7647) rotate(105) scale(9.80449)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.e56b0d48202789808608875d7dfab115.svg";
export { ForwardRef as ReactComponent };